<div *ngIf="form && questionJson"
     class="{{questionJson.wrapperClass ? questionJson.wrapperClass : ''}}">
  <ng-container *ngFor="let model of questionJson.questions">
    <div *ngIf="shouldInclude(model) && (!model.controlVisibleIf || model.controlVisibleIf())"
         class="{{model.class ? model.class : ''}}">
      <tgf-form-checkbox-question
        *ngIf="model.type === 'checkbox'"
        [questionModel]="mapQuestionModel(model)"
        [parentModel]="parentModel"
        [form]="form">
      </tgf-form-checkbox-question>
      <tgf-form-input-question
        *ngIf="model.type === 'text'"
        [questionModel]="mapQuestionModel(model)"
        [parentModel]="parentModel"
        [form]="form">
      </tgf-form-input-question>
      <tgf-form-dropdown-question
        *ngIf="model.type === 'dropdown'"
        [questionModel]="mapQuestionModel(model)"
        [parentModel]="parentModel"
        [form]="form">
      </tgf-form-dropdown-question>
      <tgf-form-radio-group-question
        *ngIf="model.type === 'radiogroup'"
        [questionModel]="mapQuestionModel(model)"
        [parentModel]="parentModel"
        [form]="form">
      </tgf-form-radio-group-question>
    </div>
  </ng-container>
  <ng-container *ngIf="afterQuestionsTemplate"
                [ngTemplateOutlet]="afterQuestionsTemplate">
  </ng-container>
</div>
